import { SupportedWorkLoads } from '../schema/SupportedWorkloadScenarios';
import { OwaWorkload } from 'owa-workloads';

export function isSupportedWorkload(workload: OwaWorkload): boolean {
    // true if SupportedWorkLoads has workload bit set
    return ((workload as number) & SupportedWorkLoads) != 0;
}
